import Constants from '../../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}dedemonstrant/`;

const title = "Holy Road - De Demonstrant";
const description = "Zijn strijd naam is Tito. Hij trekt er elke week op uit om tegen het Israëlische leger te demonstreren. Het is David tegen Goliath, zegt hij. Maar hij kan niet anders.";
const featuredImage = `${imageFolder}dedemonstrant/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}dedemonstrant`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Iframe",
        hideSpacer: true,
        url: "https://player.vimeo.com/video/214048257",
        text: "Hoe ziet het leven van een Palestijnse demonstrant eruit? Kijk hier een dag uit het leven van Tito.  "
    },
    {
        type: "Paragraph",
        text: "Vraag aan Tito waar hij vandaan komt, en hij zegt: uit Salama. Maar Salama staat niet meer op de kaart. Het was een dorp even buiten Jaffa, het eeuwenoude Arabische havenstadje dat tegenwoordig door het leven gaat als stadsdeel van Tel Aviv, in Israël. Salama werd in 1948 etnisch gezuiverd door zionistische milities, en letterlijk van de kaart geveegd. Alleen de 'Shalma Road' in Tel Aviv herinnert nog aan de vroegere Arabische bewoning. De ongeveer zevenduizend inwoners van Salama ontvluchtten hun huizen, en belandden in kampen. Ze kwamen onder meer terecht in het Am'ari-vluchtelingenkamp bij Ramallah, op de Westelijke Jordaanoever. Zo ook de familie van Tito."
    },
    {
        type: "Paragraph",
        text: "Bijna zeventig jaar later woont Tito hier nog steeds. Het is hem verboden om ook maar een dag in Tel Aviv te zijn. Ook hij strijdt, net als zijn voorvaderen, tegen de Joden – niet meer tegen zionistische milities, maar tegen het Israëlische leger. Volgens het internationaal recht hebben alle Palestijnse vluchtelingen van 1948 en hun nakomelingen – inmiddels zijn dat er zo'n vijf miljoen – het recht om terug te keren naar waar ze vandaan komen, in het tegenwoordige Israël. Maar niet alleen weigert Israël dat pertinent, ook het tegenwoordige leefgebied van Tito en zijn familie, de Westelijke Jordaanoever, wordt bezet en gekoloniseerd."
    },
    {
        type: "Paragraph",
        text: "Tegenover de Israëlische soldaten, met hun M16's en hun traangasgranaten, kunnen Tito en consorten alleen stenen en molotovcocktails plaatsen. Israël bestraft deze vorm van verzet steeds zwaarder. Palestijnse stenengooiers lopen het risico dat ze tot twintig jaar in de gevangenis belanden. Tito is inmiddels 32. Vrienden vragen hem wanneer hij eens ophoudt, en een gezinnetje sticht. Maar het verzet zit hem in het bloed, zegt hij. Hij moet strijden voor zijn land. Hij kan niet anders."
    },
]


// WEBPACK FOOTER //
// ./src/data/nl/stories/story5.js